import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: var(--gray-dark);
  color: var(--white);
  padding: 3rem 0 1rem;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 1rem;
`;

const FooterSection = styled.div`
  margin-bottom: 2rem;
`;

const FooterTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: var(--white);
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -0.5rem;
    width: 50px;
    height: 2px;
    background-color: var(--blue);
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  
  svg {
    margin-right: 0.75rem;
    color: var(--blue);
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  
  li {
    margin-bottom: 0.75rem;
    
    a {
      color: var(--white);
      text-decoration: none;
      transition: color 0.2s ease;
      display: block;
      
      &:hover {
        color: var(--blue);
        text-decoration: none;
      }
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--white);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: var(--blue);
    transform: translateY(-3px);
  }
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Contacto</FooterTitle>
          <ContactItem>
            <FaMapMarkerAlt />
            <span>Calle Merced 20 1C, Guadalajara 19001</span>
          </ContactItem>
          <ContactItem>
            <FaPhone />
            <a href="tel:+34628774688">+34 628 774 688</a>
          </ContactItem>
          <ContactItem>
            <FaEnvelope />
            <a href="mailto:hola@webabajocoste.es">hola@webabajocoste.es</a>
          </ContactItem>
          <SocialLinks>
            <SocialLink href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </SocialLink>
            <SocialLink href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </SocialLink>
            <SocialLink href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </SocialLink>
            <SocialLink href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </SocialLink>
          </SocialLinks>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Enlaces rápidos</FooterTitle>
          <FooterLinks>
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/servicios">Servicios</Link></li>
            <li><Link to="/precios">Precios</Link></li>
            <li><Link to="/proceso">Nuestro Proceso</Link></li>
            <li><Link to="/sobre-nosotros">Sobre Nosotros</Link></li>
            <li><Link to="/contacto">Contacto</Link></li>
          </FooterLinks>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Servicios</FooterTitle>
          <FooterLinks>
            <li><Link to="/servicios/diseno-web-pymes">Webs para Pymes</Link></li>
            <li><Link to="/servicios/diseno-web-autonomos">Webs para Autónomos</Link></li>
            <li><Link to="/servicios/diseno-web-empresas">Webs para Empresas</Link></li>
            <li><Link to="/servicios/landing-pages">Landing Pages</Link></li>
          </FooterLinks>
        </FooterSection>
        
        <FooterSection>
          <FooterTitle>Legal</FooterTitle>
          <FooterLinks>
            <li><Link to="/aviso-legal">Aviso Legal</Link></li>
            <li><Link to="/politica-privacidad">Política de Privacidad</Link></li>
            <li><Link to="/politica-cookies">Política de Cookies</Link></li>
          </FooterLinks>
        </FooterSection>
      </FooterContent>
      
      <Copyright>
        &copy; {currentYear} Web a Bajo Coste - Candle Dropstore Sociedad Limitada - CIF B19327030. Todos los derechos reservados.
      </Copyright>
    </FooterContainer>
  );
};

export default Footer; 